// extracted by mini-css-extract-plugin
var _1 = "GroupsView-module__animateUploadProgressBarWidth--ufBvE";
var _2 = "GroupsView-module__animatedBackground--bBgYO";
var _3 = "GroupsView-module__header--S7lh1";
var _4 = "GroupsView-module__hidden--xTG6J";
var _5 = "GroupsView-module__section--ZjLcK";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "header", _4 as "hidden", _5 as "section" }
